// @flow
import styled from 'styled-components'
import * as spacing from '../../theme/spacing'

const MarginContainer = styled.div`
  margin: 0 auto;
  max-width: ${spacing.siteWidth};
  padding-top: 0;
  border-sizing: border-box;

  @media (min-width: 600px) {
    padding: 0 30px;
    margin: 0;
  }

  @media (min-width: 1200px) {
    padding: 0;
    margin: 0 auto;
  }

  @media (max-width: 767px) {
    margin: 0;
    padding: 0 30px;
    width: auto;
    border-sizing: border-box;
  }
`

export default MarginContainer



// WEBPACK FOOTER //
// ./src/components/shared/MarginContainer.js